/*! @pentacode/ui v0.1.0 */
// src/utils/reduced-motion.ts
var e = "(prefers-reduced-motion: reduce)";
function t() {
	return typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(e).matches;
}
var n = class {
	constructor(e) {
		this.matches = t(), this._onChange = () => {
			this.matches = this._query?.matches ?? !1, this._host.requestUpdate();
		}, this._host = e, e.addController(this);
	}
	hostConnected() {
		typeof window < "u" && typeof window.matchMedia == "function" && (this._query = window.matchMedia(e), this.matches = this._query.matches, this._query.addEventListener("change", this._onChange));
	}
	hostDisconnected() {
		this._query?.removeEventListener("change", this._onChange);
	}
};
export { n as t };

//# sourceMappingURL=reduced-motion-CZnc3mB7.js.map